export default {
  props: {
    status: false
  },
  data() {
    return {};
  }
};